import dynamic from "next/dynamic";
import { memo, useEffect, useState } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import NextImage from "next/image";
import ShoppingOutlined from "@ant-design/icons/ShoppingOutlined";
import MenuOutlined from "@ant-design/icons/MenuOutlined";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import GiftOutlined from "@ant-design/icons/GiftOutlined";
import axios from "axios";
import { logout } from "../../utils/auth";
import { Api } from "../../networks/Api";
import { getCartData } from "../../redux/actions/cartActions";
import { useTranslation } from "next-i18next";
import { v4 as uuidv4 } from "uuid";

const MenuModal = dynamic(() => import("./MenuModal"), { ssr: false });
const Voucher = dynamic(() => import("./VoucherModal"), { ssr: false });
const Currency = dynamic(() => import("./CurrencyModal"), { ssr: false });

const App = ({ props, setOpenSearch, brandData, profileData }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  let queryParam = router?.query?.aid ? `aid=${router?.query?.aid}` : ``;
  queryParam = router?.query?.pid
    ? `${queryParam}&pid=${router?.query?.pid}`
    : queryParam;

  queryParam = router?.query?.pf
    ? `${queryParam}pf=${router?.query?.pf}`
    : queryParam;

  if (router?.query?.utm_source) {
    queryParam = queryParam
      ? `${queryParam}&utm_source=${router?.query?.utm_source}`
      : `?utm_source=${router?.query?.utm_source}`;
  }

  const { locale } = router;
  const changeTo = locale === "th" ? "en" : "th";
  const { t } = useTranslation("common");

  const [open, setOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);
  const [openVoucher, setOpenVoucher] = useState(false);
  const [openBrand, setOpenBrand] = useState(false);
  const [valueSearch, setValueSearch] = useState(router?.query?.search || "");
  const [filteredBrands, setFilteredBrands] = useState(brandData);
  const [fingerprint, setFingerprint] = useState(null);
  const [liveMenu, setLiveMenu] = useState(false);
  const [saleMenu, setSaleMenu] = useState(false);
  const [campaignMenu, setCampaignMenu] = useState(false);
  const categoryMenu = props?.categoryMenu;

  const redux_cart = useSelector((state) => state?.cart);
  const { currencyData } = useSelector((state) => state?.currency);
  const { currencyAllData } = useSelector((state) => state?.currencyAll);

  const noHeader = props?.noHeader;
  const disableLine = props?.disableLine || profileData?.channel == "line";

  useEffect(() => {
    let idleCallbackId;
    let timeoutId;

    const fetchDeferredHeaderData = async () => {
      axios
        .post(
          Api.getCartList,
          { uuid: storedFingerprint },
          Api.Header(props?.token),
        )
        .then((cartResponse) => {
          dispatch(getCartData(cartResponse.data.data));
        })
        .catch((e) => console.error("Error fetching cart:", e));

      try {
        const [hasSaleRes, hasCampaignRes, hasLiveRes] = await Promise.all([
          axios.get(`${Api.checkHasSaleProduct}?sell_type=sale`, Api.Header()),
          axios.get(
            `${Api.checkHasSaleProduct}?sell_type=campaign`,
            Api.Header(),
          ),
          axios.get(`${Api.checkHasLiveProduct}`, Api.Header()),
        ]);

        if (hasSaleRes?.status == 200) {
          const hasSale = hasSaleRes?.data?.has_sale_product;
          setSaleMenu(hasSale);
        }
        if (hasCampaignRes?.status == 200) {
          const hasCampaign = hasCampaignRes?.data;

          console.log(hasCampaign);
          setCampaignMenu(hasCampaign);
        }
        if (hasLiveRes?.status == 200) {
          const hasLive = hasLiveRes?.data?.has_sale_product;
          setLiveMenu(hasLive);
        }

      } catch (e) {
        console.error("Error fetching menu availability:", e);
      }
    };

    const storedFingerprint = Cookies.get("uuid") || uuidv4();
    setFingerprint(storedFingerprint);

    if (typeof window.requestIdleCallback === "function") {
      idleCallbackId = window.requestIdleCallback(fetchDeferredHeaderData, {
        timeout: 3000,
      });
    } else {
      timeoutId = window.setTimeout(fetchDeferredHeaderData, 1500);
    }

    return () => {
      if (idleCallbackId) window.cancelIdleCallback(idleCallbackId);
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, [props?.token, dispatch]);

  useEffect(() => {
    setFilteredBrands(brandData);
  }, [brandData]);

  const onSearch = (value) => {
    router.push(`/all?search=${value}${queryParam ? `&${queryParam}` : ``}`);
  };

  const handleSearch = (value) => {
    const filtered = brandData.filter((brand) =>
      brand.name.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredBrands(filtered);
  };

  const SigninComponet = () => {
    if (props?.token)
      return (
        <div
          key={`items1-3`}
          onClick={() => {
            setOpen(false);
            setOpenProfile(true);
          }}
        >
          {t("my-account")}
        </div>
      );
    else
      return (
        <div
          key={`items1-3`}
          onClick={() => {
            setOpen(false);
            router.push(`/signup${queryParam ? `?${queryParam}` : ``}`);
          }}
        >
          {t("login")}
        </div>
      );
  };

  const items1Mobile = [
    {
      key: `items1Mobile-1`,
      label: (
        <button
          onClick={() => setOpenSearch(true)}
          className="menu-icon px-2 rounded-md"
        >
          <SearchOutlined />
        </button>
      ),
    },
    {
      key: `items1Mobile-voucher`,
      label: (
        <button
          onClick={() => setOpenVoucher(true)}
          className="relative px-2 rounded-md"
        >
          <GiftOutlined />
        </button>
      ),
    },
    {
      key: `items1Mobile-2`,
      label: (
        <Link
          href={`/cart${queryParam ? `?${queryParam}` : ``}`}
          prefetch={false}
        >
          <div className="relative px-2 rounded-md">
            <ShoppingOutlined />
            {redux_cart?.cartData?.length > 0 && (
              <span className="absolute top-[-4px] right-0 bg-red-500 text-white text-xs px-1 rounded-full">
                {redux_cart?.cartData?.length}
              </span>
            )}
          </div>
        </Link>
      ),
    },
    {
      key: `items1Mobile-3`,
      label: (
        <MenuOutlined
          className="menu-icon px-2 rounded-md"
          onClick={() => setOpen(true)}
        />
      ),
    },
  ];

  return (
    <>
      {open && (
        <MenuModal
          SigninComponet={SigninComponet}
          open={open}
          setOpen={setOpen}
          setOpenBrand={setOpenBrand}
          setOpenCurrency={setOpenCurrency}
          categoryMenu={categoryMenu}
          liveMenu={liveMenu}
          saleMenu={saleMenu}
          campaignMenu={campaignMenu}
          currencyAllData={currencyAllData}
          currencyData={currencyData}
          queryParam={queryParam}
        />
      )}

      {/* Modal Profile */}
      {openProfile && <div className="fixed inset-0 flex items-start justify-center bg-black bg-opacity-50 z-[99999] transition-all">
        <div className="bg-white mx-4 mt-4 p-6 rounded-lg shadow-lg w-full max-w-[520px]">
          <div className="flex justify-between items-center pb-2">
            <h2 className="text-[16px] font-semibold">Profile</h2>
            <button
              onClick={() => setOpenProfile(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          <p className="p-2 text-[14px] font-medium">
            {profileData?.fullname || profileData?.email}
          </p>

          <div className="border-t border-gray-200 my-5" />

          <div className="space-y-1 text-[14px] px-2 pb-2">
            <button
              className="w-full text-left px-2 py-2 hover:bg-gray-100 rounded-md"
              onClick={() => {
                setOpenProfile(false);
                router.push(`/profile${queryParam ? `?${queryParam}` : ``}`);
              }}
            >
              {t("personal-information")}
            </button>
            <button
              className="w-full text-left px-2 py-2 hover:bg-gray-100 rounded-md"
              onClick={() => {
                setOpenProfile(false);
                router.push(`/order${queryParam ? `?${queryParam}` : ``}`);
              }}
            >
              {t("status-and-order-history")}
            </button>
            <button
              className="w-full text-left px-2 py-2 hover:bg-gray-100 rounded-md"
              onClick={() => {
                setOpenProfile(false);
                logout();
              }}
            >
              {t("sign-out")}
            </button>
          </div>
        </div>
      </div>}

      {/* Modal Brand */}
      {openBrand && <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 transition z-[99999]">
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-[80%] h-[80%] mx-4">
          <div className="flex justify-between items-center border-b pb-2 mb-4">
            <h2 className="text-lg font-semibold">Brand</h2>
            <button
              onClick={() => setOpenBrand(false)}
              className="text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
          </div>

          <input
            type="text"
            placeholder="ค้นหาแบรนด์"
            className="w-full p-2 border rounded-md mb-4"
            onChange={(e) => handleSearch(e.target.value)}
          />

          <div className="max-h-[75%] overflow-y-auto">
            <ul>
              {filteredBrands?.map((brand) => (
                <li
                  key={brand?.name}
                  className="p-2 cursor-pointer hover:bg-gray-100 rounded-md"
                  onClick={() => {
                    setOpenBrand(false);
                    setOpen(false);
                    router.push(
                      `/${encodeURIComponent(brand?.name)}${
                        queryParam ? `?${queryParam}` : ``
                      }`,
                    );
                  }}
                >
                  {brand?.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>}

      {openCurrency && (
        <Currency
          t={t}
          openCurrency={openCurrency}
          setOpenCurrency={setOpenCurrency}
          currencyData={currencyData}
        />
      )}

      {openVoucher && (
        <Voucher
          openVoucher={openVoucher}
          setOpenVoucher={setOpenVoucher}
          currencyData={currencyData}
          fingerprint={fingerprint}
          token={props?.token}
        />
      )}

      {noHeader ? (
        <></>
      ) : (
        <div className="header_container">
          <div className="hidden lg:block relative">
            <header className="text-sm bg-white px-12  flex justify-between items-center">
              <div className="w-[45%] flex items-center ">
                <Link
                  className="mr-4"
                  href={`/${queryParam ? `?${queryParam}` : ``}`}
                  prefetch={false}
                >
                  <div style={{ width: "200px", height: "32px" }}>
                    <NextImage
                      src="/static/images/logo.webp"
                      className="logo max-w-[200px]"
                      alt="logo"
                      width={200}
                      height={31}
                      loading="lazy"
                      unoptimized
                    />
                  </div>
                </Link>
                {profileData?.channel == "line" ? (
                  <>
                    <div className="py-5 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      &nbsp;
                    </div>
                  </>
                ) : (
                  <>
                    <div className="flex items-center border rounded-lg w-full p-2 h-7 ">
                      <SearchOutlined
                        className="mr-4"
                        onClick={() => onSearch(valueSearch)}
                      />
                      <input
                        type="text"
                        placeholder="Search for brand, color, etc."
                        className="outline-none w-full placeholder:font-light"
                        value={valueSearch}
                        onChange={(e) => setValueSearch(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            onSearch(valueSearch); // เรียกฟังก์ชันค้นหาเมื่อกด Enter
                          }
                        }}
                      />
                    </div>
                    {valueSearch && (
                      <div
                        className="ml-2 cursor-pointer text-white text-xs bg-gray-300 hover:bg-gray-400 rounded-full w-6 h-4 flex justify-center overflow-hidden"
                        onClick={() => setValueSearch("")}
                      >
                        x
                      </div>
                    )}
                  </>
                )}
              </div>

              <nav className="flex space-x-6 items-center mr-4">
                {profileData?.channel == "line" ? (
                  <>
                    <div className="py-5 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      &nbsp;
                    </div>
                  </>
                ) : (
                  <>
                    <Link
                      href={`/about${queryParam ? `?${queryParam}` : ``}`}
                      locale={changeTo}
                      prefetch={false}
                    >
                      <div className="py-5 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                        {locale === "th" ? "เกี่ยวกับเรา" : "About Us"}
                      </div>
                    </Link>

                    <div className="py-5 cursor-pointer border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      <SigninComponet />
                    </div>

                    <div
                      onClick={() => setOpenVoucher(true)}
                      className="relative py-5 cursor-pointer border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500"
                    >
                      <GiftOutlined className="menu-icon" />
                    </div>

                    <Link
                      href={`/cart${queryParam ? `?${queryParam}` : ``}`}
                      prefetch={false}
                    >
                      <div className="relative  py-5 cursor-pointer border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                        <ShoppingOutlined className="menu-icon" />
                        {redux_cart?.cartData?.length > 0 && (
                          <span className="absolute top-3 right-[-8px] bg-red-500 text-white text-xs px-1 w-4 h-4 rounded-full flex items-center justify-center border-2 border-white">
                            {redux_cart?.cartData?.length}
                          </span>
                        )}
                      </div>
                    </Link>

                    <Link
                      href={router.asPath}
                      locale={changeTo}
                      prefetch={false}
                    >
                      <div className="relative py-5 cursor-pointer border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                        <div className="flex items-center gap-2">
                          {locale === "th" ? "เปลี่ยนภาษา" : "Language"}
                          <NextImage
                            src={
                              locale === "th"
                                ? "/static/images/thai-flag.png"
                                : "/static/images/us-flag.png"
                            }
                            loading="lazy"
                            alt="Flag"
                            width={20}
                            height={20}
                            unoptimized
                          />
                        </div>
                      </div>
                    </Link>

                    <div
                      onClick={() => setOpenCurrency(true)}
                      className="relative py-5 cursor-pointer border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500"
                    >
                      {Object.keys(currencyAllData)?.length > 0 &&
                        `${currencyAllData[currencyData]?.label} (${currencyAllData[currencyData]?.symbol})`}
                    </div>
                  </>
                )}
              </nav>
            </header>

            <nav className="bg-[#F6F6F6] px-4">
              <div className="flex items-center justify-center space-x-4">
                {categoryMenu?.map((cate) => (
                  <Link
                    key={`menu-cate-${cate?.name_en}`}
                    prefetch={false}
                    href={`/${cate?.name_en}${
                      queryParam ? `?${queryParam}` : ``
                    }`}
                  >
                    <div className="text-sm py-3 px-1 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      {cate?.name_en}
                    </div>
                  </Link>
                ))}

                {liveMenu && (
                  <Link
                    href={`/live${queryParam ? `?${queryParam}` : ``}`}
                    prefetch={false}
                  >
                    <div className="text-sm py-3 px-1 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      Live Promotion
                    </div>
                  </Link>
                )}

                {saleMenu && (
                  <Link
                    href={`/sale${queryParam ? `?${queryParam}` : ``}`}
                    prefetch={false}
                  >
                    <div className="text-sm py-3 px-1 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      Sale
                    </div>
                  </Link>
                )}

                {campaignMenu?.has_sale_product && (
                  <Link
                    href={`/campaign${queryParam ? `?${queryParam}` : ``}`}
                    prefetch={false}
                  >
                    <div className="text-sm py-3 px-1 border-transparent border-b-2 hover:border-black hover:border-b-2 transition-all duration-500">
                      {locale === "th"
                        ? campaignMenu?.menu_name_en
                        : campaignMenu?.menu_name_th}
                    </div>
                  </Link>
                )}
              </div>
            </nav>
          </div>
          <div className="blog lg:hidden relative bg-white py-4 px-3">
            <div className="flex justify-between items-center">
              <div className="header_logo">
                <Link
                  href={`/${queryParam ? `?${queryParam}` : ``}`}
                  prefetch={false}
                >
                  <div className="flex">
                    <NextImage
                      src="/static/images/logo.webp"
                      className="logo"
                      alt="logo"
                      width={200}
                      height={31}
                      loading="lazy"
                      placeholder="blur"
                      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
                      unoptimized
                    />
                  </div>
                </Link>
              </div>
              {profileData?.channel == "line" ? (
                <></>
              ) : (
                <div className="style_header_menu">
                  <nav className="flex gap-1 pt-2">
                    {items1Mobile.map((item) => (
                      <div
                        key={item.key}
                        className="flex items-center cursor-pointer "
                      >
                        {item.label}
                      </div>
                    ))}
                  </nav>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default memo(App);
